<template>
    <v-data-table
        :headers="headers"
        :items="BILLING_INDEX"
        hide-actions
        class="elevation-1"
        pagination.sync="pagination"
        loading="true"
    >
        <template slot="items" slot-scope="props">
          <tr @click="$router.push({ name: 'BillingShow', params: { id: props.item.id }})">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.amount.toFixed(2).replace(".", ",") }} €</td>
          </tr>
        </template>
        <template slot="no-data">
            <p>{{ $vuetify.t('$vuetify.lobis.noResultsForPosition') }}</p>
        </template>
    </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { BILLING_INDEX, BILLING_GET } from '../../store/actions/billing'
export default {
  data () {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        {
          text: 'Betrag',
          align: 'left',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      BILLING_INDEX
    ])
  },
  mounted () {
    this.$store.dispatch(BILLING_GET)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Billing/Index.vue